/**
 * Öffentliche Schnittstelle für die Story-Mails (unverändert: getEmailData() -> { emails }).
 *
 * Die Daten selbst liegen seit dem Umbau in mail/<sprache>/<episode>.js und laufen in
 * mail/index.js zusammen. Hier steht bewusst kein Inhalt mehr.
 */
import { getAllEmails } from './mail'

export function getEmailData() {
    return { emails: getAllEmails() }
}
